(() => {
  const initFooter = (scope = document) => {
    const footers = scope.querySelectorAll('[data-wb-footer]');

    footers.forEach((footer) => {
      if (footer.dataset.wbFooterInit === 'true') return;
      footer.dataset.wbFooterInit = 'true';

      const triggers = footer.querySelectorAll('[data-wb-footer-trigger]');

      triggers.forEach((trigger) => {
        const menu = trigger.closest('.wb-footer__menu');
        if (!menu) return;

        trigger.setAttribute('aria-expanded', 'false');
        menu.classList.remove('is-open');

        trigger.addEventListener('click', () => {
          if (!window.matchMedia('(max-width: 989px)').matches) return;
          if (footer.dataset.mobileLayout !== 'accordion') return;

          const isOpen = menu.classList.contains('is-open');

          footer.querySelectorAll('.wb-footer__menu').forEach((item) => {
            const itemTrigger = item.querySelector('[data-wb-footer-trigger]');
            item.classList.remove('is-open');
            if (itemTrigger) itemTrigger.setAttribute('aria-expanded', 'false');
          });

          if (!isOpen) {
            menu.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initFooter(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initFooter(event.target);
  });
})();